import { Injectable } from "@angular/core";
@Injectable()
export class ApplicationCaseDto {
    id: number;
    caseNum: string;
    comment: string;
    dateReceived: Date;
    datePostmarked: Date;
    dateConfirmationReceived: Date;
    waiverReceived: boolean;
    waiverExpDate: Date;
    dateClosed: Date;
    requestFinding: boolean;
    claimRefund: string;
    receiptNum: string;
    applicantType: string;
    closed: boolean;
    efileId: number;
    applicant323: boolean;
    applicant323Date: Date;
    assessor323: boolean;
    assessor323Date: Date;
    public create() {
        return {
            id: 0,
            caseNum: '',
            comment: '',
            dateReceived: null,
            datePostmarked: null,
            dateConfirmationReceived: null,
            waiverReceived: false,
            waiverExpDate: null,
            dateClosed: null,
            requestFinding: false,
            claimRefund: '',
            receiptNum: '',
            applicantType: '',
            closed: false,
            efileId: 0,
            applicant323: false,
            applicant323Date: null,
            assessor323: false,
            assessor323Date: null

        }
    }
}
